import Slider from "react-slick";
import "./VideoGallery.css";
const PhotoGallery = () => {
  let settings = {
    className: "slider variable-width",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    // autoplay: true,
    speed: 1000,
    autoplaySpeed: 2000,
    infinite: true,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
    ],
  };

  const importAll = (r) => {
    return r.keys().map(r);
  };

  const images1 = importAll(
    require.context("../../image/video-gallery", false, /\.(mp4|MP4)$/)
  );

  const videoData = [
    `https://www.youtube.com/embed/d7jQVNd2hjs?si=MhUr8QvOlylHWHlx`,
    `https://www.youtube.com/embed/Ewfb4A89WYA?si=HKKxyAam3-LlcAZp`,
    `https://www.youtube.com/embed/hRGaa9PkiI0?si=cQC7gbjXPDsZh0gr`,
    `https://www.youtube.com/embed/TtpiPzMV8A0?si=aIqLtvt-PxSVH3zS`,
    `https://www.youtube.com/embed/KtuqlCAVJcc?si=ykd5PBrZ01R9RlvI`,
    `https://www.youtube.com/embed/3YvsV7vHTfg?si=GDJXGdeNYJ9_eCoC`,
    `https://www.youtube.com/embed/YtBnez4CJy4?si=9VZVP4sIyUmFupb1`,
    `https://www.youtube.com/embed/Mmwuz-VRZzo?si=a5kfCVn0CjGCuG91`,
    `https://www.youtube.com/embed/KtfN9zQLPzE?si=6OvUSS8F4gbVqnfc`,
    `https://www.youtube.com/embed/Muorh6TGYng?si=GAKxNYNU0rNigMho`,
    `https://www.youtube.com/embed/zbmVh6ojOO0?si=FaQt5OGYUuNF6MBC`,
    `https://www.youtube.com/embed/YgokwkkFjng?si=nyQI5T5f9LJ2qIPD`,
    `https://www.youtube.com/embed/saO0CwiVxlA?si=S4SKPDqbqpblv51t`,
    `https://www.youtube.com/embed/E3qIgDa_AIs?si=yHRtTZyUzF_PZB_g`,
  ];

  return (
    <div className="w-100 m-lg-auto color-blue-cyan " id="photo-gallery">
      <div className=""></div>
      <div className="f-bold f-2 mb-4 mx-4 mt-5 photo_heading">
        Video Gallery
      </div>
      <div>
        <Slider {...settings}>
          {/*images1.map((image, index) => {

            return (
              <div
                className="d-flex justify-content-center align-items-center"
                key={index}
              >
                <div className="slider-img-div">
                  <video src={image} controls className="slidervideo" />                  
                </div>
              </div>
            );
          }) */}

          {videoData.map((image, index) => {
            return (
            <div
              className="d-flex justify-content-center align-items-center" key={index}
            >
              <div className="slider-img-div">
                <iframe width="560" height="315" src={image} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>                
              </div>
            </div>
            );
          }) }
         

        </Slider>
      </div>
    </div>
  );
};

export default PhotoGallery;
